<template>
  <!-- <div>
        <form 
            id="commentForm"
            @submit.prevent="checkForm"
        >
            <input v-model="comment" placeholder="Your Comment">
            <p>{{comment}}</p>
            <p>
                <input
                    type="submit"
                    value="Submit"
                >
            </p>
        </form>


    </div> -->
  <div class="container">
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <img src="icons8-user-80.png" />
        </p>
      </figure>
      <form id="commentForm" @submit.prevent="checkForm" class="is-flex">
        <div class="media-content">
          <div class="field content">
            <div class="control">
              <textarea
                class="textarea has-fixed-size"
                placeholder="Add a comment"
                v-model="comment"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="media-right">
          <input type="submit" value="Post" class="button is-info is-size-2" />
        </div>
      </form>
    </article>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "AddComment",
  data: function() {
    return {
      comment: "",
    //   url: "https://www.google.com/", //hard coded for now
      url: decodeURIComponent(this.$route.params.url),
      output: ""
    };
  },
  methods: {
    checkForm: function() {
      // e.preventDefault();
      // console.log(e);
      let currentObj = this;
      // console.log(
      //   `Sending ${currentObj.url} and comment ${currentObj.comment}`
      // );
      let FD = new FormData();
      FD.set("linkname", currentObj.url);
      FD.set("comment", currentObj.comment);

      axios({
        method: "post",
        url: "/addcomment",
        data: FD,
        config: { headers: { "Content-Type": "multipart/form-data" } }
      })
        // axios.post('/addcomment', {
        //         linkname: "https://www.google.com/",
        //         comment: "awesome site"
        // })

        .then(function(response) {
          // currentObj.output = JSON.parse(JSON.stringify(response.data));
          currentObj.output = response.data;
          // console.log(currentObj.output.insertId);
          currentObj.comment = null;
          currentObj.$emit("newComment");
        })

        .catch(function(error) { 
          currentObj.output = error;
        });
    }
  }
};
</script>

<style scoped>
.commentForm {
  flex-grow: 1;
}
</style>
